module.exports = __webpack_public_path__ + "img/5.30052a74.jpg";